import styled from "@emotion/styled";
import React, { useEffect, useRef, useState } from "react";

import { useTicketPackageList } from "@src/hooks/deungi/useTicketPackageList";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";

import { transferToNative } from "@src/lib/WebAppBridge";

import { css } from "@emotion/react";
import { checkDevice } from "@src/components/deungi/common/utils";
import { PRODUCT_SALE_TYPE, TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";

import PackageCard from "@src/components/deungi/DeungiPackageCard";
interface CommonPackageListBoxProps {
    ticketTypeString: string;
    ticketTitle: string;
    ticketImage: string;
    multipleTicketImage?: string;
    paymentInfoBox?: React.ReactNode;
}

const CommonPackageListBox = ({
    ticketTypeString,
    ticketTitle,
    ticketImage,
    multipleTicketImage,
    paymentInfoBox,
}: CommonPackageListBoxProps) => {
    const deviceType = checkDevice();

    const [packageList, setPackageList] = useState({} as TicketPackageListResponseDto[]);

    const getPackageList = async () => {
        const saleType = deviceType === "ios" ? PRODUCT_SALE_TYPE.IOS : PRODUCT_SALE_TYPE.AOS;
        const res = await useTicketPackageList(saleType);
        if (res.data) {
            setPackageList(res.data.list);
        }
    };

    useEffect(() => {
        getPackageList();
    }, []);

    const onPackageClickHandler = (data: TicketPackageListResponseDto) => {
        if (!data) return;
        if (data?.type === ticketTypeString) {
            if (deviceType !== "android") {
                const ticketType = ["", ...Object.values(TICKET_TYPE_STRING)];
                const params = JSON.stringify({
                    productCode: data.code,
                    productType: data.type,
                    ticketType: ticketType.indexOf(data.type),
                });
                transferToNative(params, "payTicketInApp");
            } else {
                const params = JSON.stringify({
                    pgType: "kcp.IP29N",
                    product_name: data.name,
                    product_code: data.code,
                    discounted_price: data.discountPrice,
                    type: ticketTypeString,
                    searchText: "",
                });
                transferToNative(params, "payDeungiTicket");
            }
        }
    };

    return (
        <PackageCard
            title={ticketTitle}
            packages={packageList && packageList.length > 0 ? packageList.filter((el) => el.type === ticketTypeString) : []}
            singleTicketImage={ticketImage}
            multipleTicketsImage={multipleTicketImage ?? ticketImage}
            active={true}
            onTitleClick={() => {}}
            onPackageClick={onPackageClickHandler}
            onScroll={() => {}}
        />
    );
};

export default CommonPackageListBox;
